import Swiper, { Scrollbar } from "swiper";
import { getKlevuId } from "../klevu";

export default () => ({
  swiper: null,
  isMobile: null,
  showFixedHeight: null,

  viewPromotion(heading) {
    Tracking.viewPromotion("Product Slider", heading);
  },

  selectPromotion(heading) {
    Tracking.selectPromotion("Product Slider", heading);
  },

  setIsMobile() {
    this.isMobile = window.innerWidth < 1024 ? true : false;
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    this.showFixedHeight = params.has("fixedHeight");
    this.dispatchFavoritesEvent();
  },

  initSlider() {
    this.setIsMobile();
    this.swiper = new Swiper(this.$refs.slider, {
      cssMode: true,
      preloadImages: false,
      slidesPerView: "auto",
      spaceBetween: 8,
      slidesOffsetBefore: 8,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      breakpoints: {
        1024: {
          spaceBetween: 12,
          slidesOffsetBefore: 12,
        },
      },
      modules: [Scrollbar],
      preventClicks: false,
      preventClicksPropagation: false,
    });
  },

  slideNext() {
    this.swiper.slideTo(this.swiper.activeIndex + 2);
  },
  slidePrev() {
    this.swiper.slideTo(this.swiper.activeIndex - 2);
  },

  dispatchFavoritesEvent() {
    const event = new CustomEvent("shopify-wishlist:KlevuLoaded", {});
    document.dispatchEvent(event);
  },
});
